import { classes } from "../../helper";
import Icon from "../Icon";
import styles from "./Button.module.css";

import { ReactNode, useEffect, useState } from "react";

type ButtonProps = {
  text?: string;
  imgSrc?: string;
  svg?: ReactNode;
  icon?: string;
  variant: "primary" | "secondary" | "brand" | "transparent" | "ghost";
  size?:
    | "extra-small"
    | "small"
    | "medium"
    | "large"
    | "extra-large"
    | "large-text";
  isToggle?: boolean;
  toggled?: boolean;
  iconPosition?: "left" | "right";
  filterCount?: number;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const Button: React.FC<ButtonProps> = ({
  text,
  icon,
  imgSrc,
  svg,
  variant = "secondary",
  size = "medium",
  isToggle = false,
  toggled,
  iconPosition = "left",
  filterCount,
  ...htmlButtonProps
}) => {
  const [active, setActive] = useState(false);

  const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (isToggle && toggled === undefined) {
      setActive((a) => !a);
    }
    if (htmlButtonProps.onClick) {
      htmlButtonProps.onClick(event);
    }
  };

  useEffect(() => {
    if (toggled !== undefined) {
      setActive(toggled);
    }
  }, [toggled]);

  const variants = {
    primary: styles.primary,
    secondary: styles.secondary,
    brand: styles.brand,
    transparent: styles.transparent,
    ghost: styles.ghost,
  };

  const sizes = {
    "extra-small": styles.extraSmall,
    small: styles.small,
    medium: styles.medium,
    large: styles.large,
    "extra-large": styles.extraLarge,
    "large-text": styles.largeText,
  };

  return (
    <button
      className={classes(
        styles.button,
        active ? styles.active : "",
        sizes[size],
        variants[variant],
        iconPosition === "right" ? ` ${styles.reversed}` : ""
      )}
      {...htmlButtonProps}
      type={htmlButtonProps.type}
      onClick={onClick}
    >
      {icon && <Icon name={icon} className={styles.icon} />}
      {imgSrc && <img src={imgSrc} alt="" />}
      {svg && <div className={styles.icon}>{svg}</div>}
      {text && (
        <span className={styles.text}>
          {text}
          {filterCount !== undefined && filterCount > 0
            ? ` (${filterCount})`
            : ""}
        </span>
      )}
      {htmlButtonProps.children}
    </button>
  );
};

export default Button;
